class Auth {

    saveUserSession(key, value, expirationDate) {
        let newValue = {
            value: value,
            expirationDate: expirationDate.toISOString()
        }
        window.sessionStorage.setItem(key, JSON.stringify(newValue))
    }

    isAuthenticated() {
        const currentDate = new Date().toISOString();
        if (!sessionStorage.getItem('tokenExpiration') ||
            (sessionStorage.getItem('tokenExpiration') && JSON.parse(sessionStorage.getItem('tokenExpiration')).expirationDate) <= currentDate) {
            return false;
        }
        return true;
    }

    logOut() {
        this.clearStorages();
        this.removeToken();
        window.location.href = '/';
    }

    removeToken() {
        sessionStorage.removeItem('tokenExpiration');
    }

    clearStorages() {
        sessionStorage.clear();
        localStorage.clear();
    }
}

export default new Auth();